import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bottom-hooks',
  templateUrl: './bottom-hooks.component.html',
  styleUrls: ['./bottom-hooks.component.scss']
})
export class BottomHooksComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
